import {
  brandEntityId,
  BrandEntityId,
  brandTitle,
  BrandTitle
} from "@common/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";

export class BrandUpdateVO {
  private static validation = JsonSchemaValidator.compile(
    BrandUpdateVO.validationSchema()
  );

  constructor(readonly value: BrandUpdate) {
    JsonSchemaValidator.assert(BrandUpdateVO.validation, value);
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["id", "title"],
      properties: {
        id: brandEntityId,
        title: brandTitle
      },
      additionalProperties: false
    };
  }
}

interface BrandUpdate {
  id: BrandEntityId;
  title: BrandTitle;
}
